<template>
  <ElForm
    :model="exportDetails"
    ref="export-guests-form"
    label-position="top"
    label-width="120px"
    :disabled="guestsIsEmpty"
    status-icon
    @submit.native.prevent
  >
    <ElFormItem
      prop="guestSelection"
      label="Guest selection"
    >
      <ElRadioGroup
        v-model="exportDetails.guestSelection"
        class="flex flex-wrap"
      >
        <ElRadio
          label="all"
          :title="guestSelectionOptions.all"
          class="mt-7"
        >
          {{ guestSelectionOptions.all }}
        </ElRadio>
        <ElRadio
          label="filtered"
          :title="guestSelectionOptions.filtered"
          :disabled="!anyFilterIsSelected"
          class="mt-7"
        >
          {{ guestSelectionOptions.filtered }}
        </ElRadio>
      </ElRadioGroup>
    </ElFormItem>

    <ElFormItem
      prop="fileFormat"
      label="File format"
    >
      <ElRadioGroup
        v-model="exportDetails.fileType"
        class="flex flex-wrap"
      >
        <ElRadio
          label="Excel"
          title="Export to Excel as XLSB/XLSX/XLS file"
          class="mt-7"
        />
        <ElRadio
          label="CSV"
          title="Export as CSV file"
          class="mt-7"
        />
      </ElRadioGroup>
    </ElFormItem>

    <ElFormItem prop="fileName">
      <template slot="label">
        File name <span class="font-normal text-sm italic">- Optional</span>
      </template>
      <ElInput
        v-model="exportDetails.fileName"
        :placeholder="eventTitle"
      >
        <template
          v-if="exportDetails.fileType === 'CSV'"
          slot="append"
        >
          .csv
        </template>
        <ElSelect
          v-else
          v-model="exportDetails.fileFormat"
          slot="append"
        >
          <ElOption
            label=".xlsb"
            value="xlsb"
          />
          <ElOption
            label=".xlsx"
            value="xlsx"
          />
          <ElOption
            label=".xls"
            value="xls"
          />
        </ElSelect>
      </ElInput>
    </ElFormItem>

    <ElCollapse v-model="activeUncollapsedItem">
      <ElCollapseItem name="advanced-options">
        <template slot="title">
          <h3 class="inline text-lg text-primary m-0">Advanced options</h3>
        </template>

        <ElFormItem
          label="Export barcode value"
          prop="exportQRCodeData"
        >
          <ElSwitch v-model="exportDetails.exportQRCodeData" />
        </ElFormItem>
      </ElCollapseItem>
    </ElCollapse>
  </ElForm>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import guestPluralRules from '@/utils/pluralRules/guest';
import extraGuestPluralRules from '@/utils/pluralRules/extraGuest';

export default {
  props: {
    eventTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    const exportDetails = { ...this.$store.state.guest.export.exportDetails };
    exportDetails.guestSelection = this.$store.getters['guest/filter/anyFilterIsSelected'] ? 'filtered' : 'all';

    return {
      exportDetails,
      activeUncollapsedItem: [],
    };
  },
  watch: {
    dialogIsVisible: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.exportDetails.guestSelection = this.$store.getters['guest/filter/anyFilterIsSelected'] ? 'filtered' : 'all';
        }
      },
    },
    exportDetails: {
      immediate: true,
      deep: true,
      handler(value) {
        this.updateExportDetails({ ...value });
      },
    },
    'exportDetails.fileType': {
      handler(newValue) {
        if (newValue === 'Excel') this.exportDetails.fileFormat = 'xlsb';
        else this.exportDetails.fileFormat = 'csv';
      },
    },
  },
  computed: {
    ...mapState('guest', {
      guestsCounts: 'guestsCounts',
    }),
    ...mapState('guest/export', {
      dialogIsVisible: 'dialogIsVisible',
    }),
    ...mapGetters('guest', {
      guestsIsEmpty: 'guestsIsEmpty',
    }),
    ...mapGetters('guest/filter', {
      filteredGuests: 'filteredGuests',
      anyFilterIsSelected: 'anyFilterIsSelected',
    }),
    guestSelectionOptions() {
      let filtered = 'Filtered (Select a filter)';
      if (this.anyFilterIsSelected) {
        filtered = `Filtered - ${guestPluralRules(this.filteredGuests.guestsCounts.mainGuest)} ${this.filteredGuests.guestsCounts.extraGuest ? `(+${extraGuestPluralRules(this.filteredGuests.guestsCounts.extraGuest)})` : ''}`;
      }

      return {
        all: `All - ${guestPluralRules(this.guestsCounts.mainGuest)} ${this.guestsCounts.extraGuest ? `(+${extraGuestPluralRules(this.guestsCounts.extraGuest)})` : ''}`,
        filtered,
      };
    },
  },
  methods: {
    ...mapActions('guest/export', {
      updateExportDetails: 'updateExportDetails',
    }),
  },
};
</script>

<style scoped>
>>> .el-select .el-input {
  width: 100px;
}
</style>
